import { render, staticRenderFns } from "./IntegrationFormOpsgenie.vue?vue&type=template&id=e9624f8e&scoped=true"
import script from "./IntegrationFormOpsgenie.vue?vue&type=script&lang=js"
export * from "./IntegrationFormOpsgenie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9624f8e",
  null
  
)

export default component.exports